<!-- ── Sidebar ── -->
<nav
  class="sidebar"
  [class.collapsed]="collapsed"
  role="navigation"
  aria-label="Navigation principale"
>
  <!-- ── Brand + toggle PC ── -->
  <div class="sidebar-brand">
    <div class="logo-box">
      <img [src]="brandLogoUrl" class="logo-full" alt="CNSS" />
    </div>

    <!-- Bouton collapse visible uniquement PC -->
    <button
      class="sidebar-toggle-btn"
      type="button"
      (click)="toggleCollapse()"
      [attr.aria-label]="collapsed ? 'Déplier le menu' : 'Replier le menu'"
      [attr.aria-expanded]="!collapsed"
    >
      <mat-icon>{{ collapsed ? "menu_open" : "menu" }}</mat-icon>
    </button>
  </div>

  <!-- ── Scroll ── -->
  <div class="sidebar-scroll">
    <ul class="sidebar-nav__list" role="list">
      <ng-container *ngFor="let item of menuItems">
        <li
          *ngIf="hasAccess(item.roles)"
          class="sidebar-nav__item"
          [attr.data-tooltip]="item.label"
        >
          <!-- Lien simple -->
          <a
            *ngIf="!hasChildren(item)"
            class="sidebar-link"
            [routerLink]="item.link"
            routerLinkActive="sidebar-link--active"
            [routerLinkActiveOptions]="
              item.link === routeAlias.home ? { exact: true } : { exact: false }
            "
            (click)="onClickMenu()"
            [attr.aria-label]="item.label"
          >
            <mat-icon class="sidebar-link__icon">{{ item.icon }}</mat-icon>
            <span class="sidebar-link__label">{{ item.label }}</span>
            <span *ngIf="item.badge" class="sidebar-badge">{{
              item.badge
            }}</span>
          </a>

          <!-- Groupe dropdown niveau 1 -->
          <ng-container *ngIf="hasChildren(item)">
            <button
              type="button"
              class="sidebar-link sidebar-link--group"
              [class.sidebar-link--group-active]="hasActiveChild(item)"
              [class.sidebar-link--open]="item._open"
              (click)="toggleGroup(item, $event)"
              [attr.aria-expanded]="item._open"
              [attr.aria-haspopup]="true"
            >
              <mat-icon class="sidebar-link__icon">{{ item.icon }}</mat-icon>
              <span class="sidebar-link__label">{{ item.label }}</span>
              <span
                *ngIf="item.badge && !collapsed"
                class="sidebar-badge sidebar-badge--soft"
                >{{ item.badge }}</span
              >
              <mat-icon *ngIf="!collapsed" class="sidebar-chevron"
                >expand_more</mat-icon
              >
            </button>

            <div
              class="sidebar-submenu"
              [class.sidebar-submenu--open]="item._open && !collapsed"
              role="region"
              [attr.aria-label]="item.label + ' sous-menu'"
            >
              <ul class="sidebar-submenu__list" role="list">
                <ng-container *ngFor="let child of item.children">
                  <li
                    *ngIf="hasAccess(child.roles)"
                    class="sidebar-submenu__item"
                  >
                    <!-- Enfant simple -->
                    <a
                      *ngIf="!hasChildren(child)"
                      class="sidebar-sublink"
                      [routerLink]="child.link"
                      routerLinkActive="sidebar-sublink--active"
                      (click)="onClickMenu()"
                    >
                      <mat-icon
                        *ngIf="child.icon"
                        class="sidebar-sublink__icon"
                        >{{ child.icon }}</mat-icon
                      >
                      <span class="sidebar-sublink__label">{{
                        child.label
                      }}</span>
                      <span *ngIf="child.badge" class="sidebar-badge">{{
                        child.badge
                      }}</span>
                    </a>

                    <!-- Enfant dropdown niveau 2 -->
                    <ng-container *ngIf="hasChildren(child)">
                      <button
                        type="button"
                        class="sidebar-sublink sidebar-sublink--group"
                        [class.sidebar-sublink--group-active]="
                          hasActiveChild(child)
                        "
                        [class.sidebar-sublink--open]="child._open"
                        (click)="toggleGroup(child, $event)"
                        [attr.aria-expanded]="child._open"
                      >
                        <mat-icon
                          *ngIf="child.icon"
                          class="sidebar-sublink__icon"
                          >{{ child.icon }}</mat-icon
                        >
                        <span class="sidebar-sublink__label">{{
                          child.label
                        }}</span>
                        <mat-icon class="sidebar-chevron sidebar-chevron--sm"
                          >expand_more</mat-icon
                        >
                      </button>

                      <div
                        class="sidebar-submenu sidebar-submenu--nested"
                        [class.sidebar-submenu--open]="child._open"
                      >
                        <ul class="sidebar-submenu__list" role="list">
                          <li
                            *ngFor="let grand of child.children"
                            class="sidebar-submenu__item"
                          >
                            <a
                              *ngIf="hasAccess(grand.roles)"
                              class="sidebar-sublink sidebar-sublink--deep"
                              [routerLink]="grand.link"
                              routerLinkActive="sidebar-sublink--active"
                              (click)="onClickMenu()"
                            >
                              <mat-icon
                                *ngIf="grand.icon"
                                class="sidebar-sublink__icon"
                                >{{ grand.icon }}</mat-icon
                              >
                              <span class="sidebar-sublink__label">{{
                                grand.label
                              }}</span>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </ng-container>
                  </li>
                </ng-container>
              </ul>
            </div>
          </ng-container>
        </li>
      </ng-container>
    </ul>
  </div>

  <!-- ── Footer avec dropdown ── -->
  <div
    class="sidebar-footer"
    [class.footer-dropdown-active]="footerDropdownOpen"
  >
    <!-- Dropdown (s'ouvre vers le haut) -->
    <div
      class="footer-dropdown"
      [class.footer-dropdown--open]="footerDropdownOpen && !collapsed"
      role="menu"
      aria-label="Menu utilisateur"
    >
      <ng-container *ngFor="let f of footerMenuItems">
        <a
          *ngIf="hasAccess(f.roles) && f.action === 'link'"
          class="footer-dropdown__item"
          [routerLink]="f.link"
          routerLinkActive="footer-dropdown__item--active"
          role="menuitem"
          (click)="onClickMenu(); closeFooterDropdown()"
        >
          <mat-icon>{{ f.icon }}</mat-icon>
          <span class="footer-dropdown__label">{{ f.label }}</span>
        </a>
      </ng-container>

      <div class="footer-dropdown__divider"></div>

      <!--      <button
        type="button"
        class="footer-dropdown__item footer-dropdown__item--logout"
        role="menuitem"
        (click)="logout()"
      >
        <mat-icon>logout</mat-icon>
        <span class="footer-dropdown__label">Déconnexion</span>
      </button> -->
    </div>

    <!-- Bouton déclencheur -->
    <button
      type="button"
      class="footer-user-btn"
      [class.footer-user-btn--open]="footerDropdownOpen"
      (click)="toggleFooterDropdown($event)"
      [attr.aria-expanded]="footerDropdownOpen"
      aria-haspopup="true"
      [attr.aria-label]="user?.name || 'Menu utilisateur'"
      [attr.data-tooltip]="user?.name || 'Utilisateur'"
    >
      <mat-icon class="footer-user-btn__avatar">brightness_low</mat-icon>

      <ng-container *ngIf="!collapsed">
        <div class="footer-user-btn__info">
          <span class="footer-user-btn__name">Administration</span>
          <!-- <span class="footer-user-btn__role">{{ user?.role }}</span> -->
        </div>
        <mat-icon
          class="footer-user-btn__chevron"
          [class.footer-user-btn__chevron--up]="footerDropdownOpen"
        >
          expand_less
        </mat-icon>
      </ng-container>
    </button>
  </div>
</nav>
